import * as yup from "yup";

export default function schema(){
    const schema = yup.object({
        username: yup.string().email("Your username is the email you used to register yourself").required("Please enter your username"),
        sesame1: yup.string().required('Please Enter your password')
    });
    return schema;
}
